import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=04b14ddf&scoped=true"
import script from "./PartnerDetail.vue?vue&type=script&lang=js"
export * from "./PartnerDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetail.vue?vue&type=style&index=0&id=04b14ddf&prod&lang=stylus&scoped=true"
import style1 from "./PartnerDetail.vue?vue&type=style&index=1&id=04b14ddf&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b14ddf",
  null
  
)

export default component.exports